import { Trans } from '@lingui/react/macro'
import { Button, Card, Group, Image, Stack, Text } from '@mantine/core'
import facePng from '../../../assets/images/face.png'

interface NoSubscriptionCardProps {
  onGetStartedClick: () => void
}

export function NoSubscriptionCard({
  onGetStartedClick,
}: NoSubscriptionCardProps) {
  return (
    <Card withBorder p="md" bg="orange.0">
      <Group gap="md" align="center">
        <Image src={facePng} alt="Markku" w={56} h={56} fit="contain" />
        <Stack gap={4} style={{ flex: 1 }}>
          <Text fw={600} size="sm">
            <Trans>Let Markku take care of it!</Trans>
          </Text>
          <Text size="xs" c="dimmed">
            <Trans>No stress, no hard work - just a well-maintained home</Trans>
          </Text>
        </Stack>
        <Button
          variant="filled"
          color="brandOrange"
          size="xs"
          onClick={onGetStartedClick}
        >
          <Trans context="subscription">Get started</Trans>
        </Button>
      </Group>
    </Card>
  )
}
